import React from 'react';
import { Box, Card, CardContent, Typography, Stack } from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import WarningIcon from '@mui/icons-material/Warning';
import TotalIcon from '@mui/icons-material/AllInbox';
import { LoadingWrapper } from '../loading';
import useResponsive from '../../hooks/useResponsive';

const InventoryStatsCards = ({ stats, isLoading }) => {
  const mdUp = useResponsive('up', 'md');

  return (
    <LoadingWrapper
      isLoading={isLoading}
      loadingType="skeleton"
      skeletonCount={4}
      gridProps={{ xs: 12, sm: 6, md: 3 }}
      containerSx={{ marginY: 3 }}
    >
      <Box display={mdUp ? 'flex' : ''} gap={2} marginY={3}>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Total Items
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <InventoryIcon color="primary" />
              <Typography variant="h5">{stats.total_items || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Total Quantity
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <TotalIcon color="primary" />
              <Typography variant="h5">{stats.total_quantity || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Low Stock Items
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <WarningIcon color="warning" />
              <Typography variant="h5" color="warning.main">{stats.low_stock_items || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Contributors
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <CategoryIcon color="primary" />
              <Typography variant="h5">{stats.added_by_breakdown?.length || 0}</Typography>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </LoadingWrapper>
  );
};

export default InventoryStatsCards;